import styled, { css } from "styled-components";
import { Body } from "@diana-ui/typography";
/**
 * Component wrapper
 */

export var Wrapper = /*#__PURE__*/ styled.div.withConfig({
  displayName: "Radiostyle__Wrapper"
})(_ref => {
  var { theme } = _ref;
  return css(["display:flex;align-items:center;&.error{color:", ";}"], theme.colors.alert.alert50);
});
export var StyledInput = /*#__PURE__*/ styled.input.withConfig({
  displayName: "Radiostyle__StyledInput"
})(_ref2 => {
  var { theme, hasChildren } = _ref2;
  return css(
    ["color:", ";cursor:pointer;", " ", ".disabled &{cursor:default;}"],
    theme.colors.primary,
    hasChildren && {
      display: "none"
    },
    Wrapper
  );
});
export var StyledLabel = /*#__PURE__*/ styled.label.withConfig({
  displayName: "Radiostyle__StyledLabel"
})(_ref3 => {
  var { theme } = _ref3;
  return css(
    ["cursor:pointer;", ".disabled &{cursor:default;}", ".error &{color:", ";}"],
    Wrapper,
    Wrapper,
    theme.colors.alert.alert50
  );
});
export var StyledBody = /*#__PURE__*/ styled(Body).withConfig({
  displayName: "Radiostyle__StyledBody"
})([""]);
